import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BasicRequestData, UserOwnedRequests } from 'src/app/models/api/simple-request-information-model';
import { UserService } from 'src/app/services/api-clients/user.api-clien';
import { ToastService } from 'src/app/services/toast.service';


export const deleteUserModalOptions: NgbModalOptions = {
  keyboard: false,
  centered: true,
  size: 'md',
  windowClass: 'dialog-bg-white'
};

@Component({
  templateUrl: './delete-user.modal.html'
})
export class DeleteUserModal implements OnInit {

  /** (Guid) Id of the User to Delete - Required for delete */
  public userGuid!: string;
  /** Username of the User to Delete - Used to display what the user is about to delete */
  public userName!: string;

  private translations = <any>{};

  public allowedToDeleteUser: boolean = false;

  public isOfSameOrganisation: boolean = false;

  public deleteYourself: boolean = false;

  public hasRequests: boolean = false;

  public requests: BasicRequestData[] = [];

  constructor(private activeModal: NgbActiveModal, private toastService: ToastService, private userService: UserService, private translateService: TranslateService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }


  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
    this.getOwnerRequest();
  }

  closeWithoutDeleting() {
    this.activeModal.close(false);
  }



  getOwnerRequest() {
    this.userService.getUserRequests(this.userGuid).subscribe({
      error: () => {
        let errorMessage = this.translateService.instant('Toasts.RemoveUserGetRequestsError', { user: this.userName });
        this.toastService.showError(this.translations.toastRemoveUserGetRequestsHeader, errorMessage);
      },
      next: (requestÌnfo: UserOwnedRequests) => {
        this.isOfSameOrganisation = requestÌnfo.isOfSameOrganisation,
        this.deleteYourself = requestÌnfo.isSameUser,
        this.allowedToDeleteUser = requestÌnfo.allowedToDelete,
        this.hasRequests = requestÌnfo.hasRequest

        requestÌnfo.requests.forEach((r: BasicRequestData) => {
          let request: BasicRequestData = {
            requestStatus: r.requestStatus,
            requestName: r.requestName,
            requestGuid: r.requestGuid
          };
          this.requests.push(request);
        });
      }
    });
  }

  async deleteUser() {
    (await this.userService.deleteUserAndSetNewOwner(this.userGuid)).subscribe({
      error: () => {
        this.toastService.showError(this.translations.toastRemoveUserHeader, this.translations.toastsRemoveUserError);
        this.activeModal.close(false);
      },
      next: () => {
        this.activeModal.close(true);
        this.toastService.showSuccess(this.translations.toastDeletedHeader, this.translations.toastsRemoveUserSuccess);
      }
    });
  }

  private getTranslations() {
    this.translateService.get([
      'Toasts.RemoveUserError',
      'Toasts.RemoveUserSuccess',
      'Toasts.RemoveUserHeader',
      'Toasts.Deleted',
      'Toasts.RemoveUserGetRequestsHeader',
      'Toasts.RemoveUserGetRequestsError',
    ]).subscribe(translation => {
      this.translations.toastsRemoveUserError = translation['Toasts.RemoveUserError'];
      this.translations.toastsRemoveUserSuccess = translation['Toasts.RemoveUserSuccess'];
      this.translations.toastRemoveUserHeader = translation['Toasts.RemoveUserHeader'];
      this.translations.toastDeletedHeader = translation['Toasts.Deleted'];
      this.translations.toastRemoveUserGetRequestsHeader = translation['Toasts.RemoveUserGetRequestsHeader'];
    });
  }
}
